import * as types from "../types/campanhas";

const INITIAL_STATE = {
  loadingConfig: false,
  banners: [],


};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CAMPANHAS_LOADING:
      return { ...state, loadingConfig: action.payload };

    case types.CAMPANHAS_DATA:
       return { ...state, banners: action.payload };


    default:
      return state;
  }
};

